import { MakeCall } from 'ha/services/apiV2/createMakeCall';

export default (makeCall: MakeCall) =>
  (conversationId: number, messageId: number) =>
    makeCall<undefined>(
      'DELETE',
      `/api/v2/conversation/${conversationId}/message/${messageId}`,
    );
